<template>
  <div class="tools-top-bar">
    <router-link to="/">
      <img src="../assets/white-icon.svg" alt="GoBeyondDev" class="top-bar-icon" />
    </router-link>
  </div>
  <div class="tools-page-header">
    <h1>The Tools</h1>
  </div>
  <div class="tools-page">
    <div class="centered-content-box">
      <p><span class="tool-name-script">Hey, It's Me</span> <br><em>Hey, It's Me</em> 
        is a tool that helps you improve your relationship with the most important 
        person in your life — you. This is especially important if you're working on 
        being kinder to yourself or growing in new ways. You write messages — only 
        you know what you truly need to hear — and Hey, It's Me delivers your messages 
        to you throughout the week, like a thoughtful friend checking in at just the 
        right time. It's a gentle way to keep your inner voice supportive, your 
        insights alive, and your self-connection growing.
            </p>
      <p style="text-align: center;">Free</p>
      <a class="learn-more-link" href="https://heyitsme.app" target="_blank" rel="noopener">Learn More</a>
    </div>
    <div class="centered-content-box">
      <p><span class="tool-name-script">Paper Boat</span> <br><em>Paper Boat</em> 
        is a creative journaling app designed to help you set your thoughts free. 
        Enjoy beautiful artwork, a calming interface, and a space to reflect. This 
        is a safe place to get out whatever it is that's bothering you, or even 
        type an angry message to someone that you don't plan on sending. Your 
        journal entry is not saved, stored or sent anywhere. Once you click Set it Free, 
        your entry is gone. Allow yourself to let go of what is no longer serving you.
        </p>
      <p style="text-align: center;">Free</p>
      <a class="learn-more-link" href="https://paperboatjournal.app" target="_blank" rel="noopener">Learn More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolsPage'
}
</script>

<style scoped>
.tools-top-bar {
  width: 100%;
  height: 60px;
  background-color: #5F593F;
  margin-top: -32px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  box-sizing: border-box;
}
.top-bar-icon {
  height: 44px;
  width: auto;
  display: block;
}
.back-button {
  position: absolute;
  top: 8px;
  left: 24px;
  z-index: 10;
  display: inline-block;
  line-height: 0;
}
.back-button img {
  height: 150px;
  width: auto;
  object-fit: contain;
  transition: opacity 0.2s;
  margin-left: 50px;
}
.back-button:hover img {
  opacity: 0.75;
}
.tools-page-header {
  position: relative;
}
.tools-main-heading-centered {
  font-family: 'Oswald', 'Pacifico', cursive, sans-serif;
  letter-spacing: 1px;
  font-size: 1.7rem;
  font-weight: 325;
  text-shadow: 0 1px 0 #fff, 0 1.5px 0 #fff, 0 2px 4px rgba(0,0,0,0.04);
  color: #000;
  margin: 4px 0 32px 0;
  white-space: normal;
  text-align: center;
  padding-top: 0;
}
.tools-page {
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  width: 100vw;
  box-sizing: border-box;
}
.tools-page-header h1 {
  margin-bottom: 0px;
  color: #000;
  font-size: 2.5rem;
  font-family: 'Oswald', cursive, sans-serif;
  font-weight: 400;
  letter-spacing: 0.5px;
}
@media (max-width: 700px) {
  .tools-page-header h2 {
    font-size: 1.7rem;
    margin: 0px 0 0 0 !important;
    padding-top: 18px;
    padding-left: 0;
    padding-right: 0;
  }
  .tools-page-header h2 br {
    display: none;
  }
  .centered-content-box {
    width: 95vw;
    min-width: unset;
    max-width: 98vw;
    padding: 16px 8px;
    margin-left: 2vw;
    margin-right: 2vw;
    box-sizing: border-box;
  }
  .desktop-break {
    display: none;
  }
}
@media (min-width: 701px) {
  .tools-page-header h2 br {
    display: inline;
  }
}
.centered-content-box {
  width: 65vw;
  min-width: 320px;
  max-width: 600px;
  margin: 24px auto 0 auto;
  padding: 24px 20px;
  background: #f2f2f2;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Quicksand', 'Pacifico', cursive, sans-serif;
  font-weight: 400;
  font-size: 1.05rem;
  letter-spacing: 1px;
  color: #222;
}
@media (max-width: 700px) {
  .centered-content-box {
    width: 95vw;
    min-width: unset;
    max-width: 98vw;
    padding: 16px 8px;
    margin-left: 2vw;
    margin-right: 2vw;
    box-sizing: border-box;
  }
  .desktop-break {
    display: none;
  }
}
@media (min-width: 701px) {
  .desktop-break {
    display: inline;
  }
}
.coming-soon-script {
  font-family: 'Pacifico', cursive, sans-serif;
  color: #5F593F;
  font-size: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.5px;
  margin: 0px 0 0 0;
}
.hey-its-me-logo-img-stacked-centered {
  height: 80px;
  width: auto;
  max-width: 90vw;
  display: block;
  margin: 40px auto 0px auto;
  object-fit: contain;
}
@media (max-width: 700px) {
  .hey-its-me-logo-img-stacked-centered {
    height: 56px;
    width: auto;
    max-width: 90vw;
    object-fit: contain;
  }
}
.learn-more-link {
  display: inline;
  margin: 0 0 0 0px;
  font-size: 1.08rem;
  color: #a3471a;
  text-decoration: underline;
  font-weight: 500;
  transition: color 0.2s;
}
.learn-more-link:hover {
  color: #c75c1a;
  text-decoration: none;
}
.footer-logo-img {
  height: 50px;
  width: auto;
  max-width: 40vw;
  display: block;
  margin: 0 auto 0 auto;
  cursor: pointer;
  transition: transform 0.15s;
  object-fit: contain;
}
.tool-name-script {
  font-family: 'Pacifico', cursive, sans-serif;
  font-size: 1.2em;
  font-weight: 400;
  letter-spacing: 0.5px;
  color:#5F593F;
  white-space: nowrap;
  text-align: left;
  width: 100%;
  margin-bottom: 0;
}
@media (max-width: 700px) {
  .footer-logo-img {
    max-width: 150px;
    width: 75vw;
    height: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto 0 auto;
  }
}
.tools-footer-logo-container {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 0;
  padding-bottom: 0;
}
.tools-footer-logo-spacer {
  flex: 1 1 auto;
}
</style>
